
const dbConfig = {
  name: process.env.DB_NAME,
  storeName: process.env.DB_STORE_NAME,
  key: process.env.DB_CRYPT_KEY,
};

export { dbConfig };
